import { create } from "zustand";

type UserType = { user: string; password?: string };

export const useUser = create<{
  user: UserType | null;
  setUser: (user?: UserType) => void;
}>((set) => ({
  user: JSON.parse((localStorage.getItem("account") || null) as string),
  setUser: (user?: UserType) =>
    set(() => {
      if (user) {
        localStorage.setItem("account", JSON.stringify(user));
      } else {
        localStorage.removeItem("account");
      }
      return { user };
    }),
}));
